import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { changeEnvForm } from './change-env-form.schema';
import { useGetDynamicEnvsQuery } from 'api/qa-env/qa-env';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { getEnvSessionData } from 'components/change-env/change-env.utils';

export const useChangeEnvForm = open => {
  const { data, isFetching, isError } = useGetDynamicEnvsQuery(
    !open ? skipToken : undefined,
  );

  const form = useForm({
    resolver: yupResolver(changeEnvForm),
    defaultValues: changeEnvForm.cast(getEnvSessionData() ?? {}),
  });

  return { form, isFetching, isError, data };
};
